<template>
  <el-dialog 
    title="挂单列表" 
    :visible.sync="dialogVisible" 
    width="1200px" 
    append-to-body 
    :modal-append-to-body="false" 
    tabindex="0" 
    @open="onDialogOpen"
    @close="onDialogClose"
  >
    <div style="display: flex; gap: 20px;">
  
      <!-- 左侧：挂单列表 -->
      <div style="flex: 1; min-width: 400px;">
        <h4 style="margin: 0 0 10px 0; color: #606266;">挂单列表</h4>
        <el-table 
          ref="holdOrderTable" 
          :data="holdOrderList" 
          border 
          height="320px" 
          highlight-current-row 
          :row-class-name="getHoldOrderRowClassName" 
          @keydown.native="handleHoldOrderDialogKeydown"
          @row-dblclick="onHoldOrderRowClick" 
          @row-click="onHoldOrderRowTwoClick" 
          @current-change="onHoldOrderSelectionChange" 
          tabindex="0"
        >
          <el-table-column prop="remark" label="备注" min-width="120" />
          <el-table-column prop="createrName" label="操作员" min-width="120" ></el-table-column>
          <el-table-column prop="createTime" label="挂单时间" min-width="160" >
            <template slot-scope="scope">
              {{ $common.getLocalTime(scope.row.createTime, true) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="restoreHoldOrder(scope.row)">还原</el-button>
              <el-button type="primary" v-if="flag" size="mini" @click="print(scope.row)">打印小票</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 右侧：挂单明细 -->
      <div style="flex: 1; min-width: 500px;">
        <h4 style="margin: 0 0 10px 0; color: #606266;">挂单明细</h4>
        <el-table 
          :data="selectedHoldOrderDetails" 
          border 
          height="320px" 
          empty-text="请选择左侧挂单查看明细"
        >
          <el-table-column prop="bgmName" label="商品名称" min-width="150" show-overflow-tooltip />
          <el-table-column prop="spec" label="规格" width="80" show-overflow-tooltip />
          <el-table-column prop="quantity" label="数量" width="80" align="center" />
          <el-table-column prop="actualPrice" label="单价" width="80" align="right">
            <template slot-scope="scope">
              {{ (scope.row.actualPrice || 0).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="金额" width="90" align="right">
            <template slot-scope="scope">
              {{ (scope.row.amount || 0).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="batchno" label="批号" width="100" show-overflow-tooltip />
        </el-table>
      </div>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'HoldOrderListDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    holdOrderList: {
      type: Array,
      default: () => []
    },
    memberInfo: {
      type: Object,
      default: () => ({})
    },
    flag:{
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      selectedHoldOrderIndex: -1, // 挂单弹窗选中索引
      selectedHoldOrderDetails: [], // 选中挂单的明细数据
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    print(row){
      console.log(row,"测试");
      this.$emit('print-hold-order', row);
    },
    // 弹窗打开事件
    onDialogOpen() {
      // 清空明细数据
      this.selectedHoldOrderDetails = [];
      
      this.$nextTick(() => {
        if (this.$refs.holdOrderTable) {
          this.$refs.holdOrderTable.$el.focus();
          // 如果有挂单数据，默认选中第一个
          if (this.holdOrderList.length > 0) {
            this.$refs.holdOrderTable.setCurrentRow(this.holdOrderList[0]);
            this.onHoldOrderSelectionChange(this.holdOrderList[0]);
            this.selectedHoldOrderIndex = 0;
          }
        }
      });
      
      this.$emit('opened');
    },
    
    // 弹窗关闭事件
    onDialogClose() {
      this.$emit('close');
    },
    
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
    },
    
    // 挂单选择变化事件
    onHoldOrderSelectionChange(currentRow) {
      console.log(currentRow,"测试");
      
      if (!currentRow || !currentRow.jsonContent) {
        this.selectedHoldOrderDetails = [];
        return;
      }
      // 设置明细数据
      this.selectedHoldOrderDetails = JSON.parse(currentRow.jsonContent).cartItems || [];
    },
    
    // 挂单弹窗键盘事件
    handleHoldOrderDialogKeydown(event) {
      if (!this.dialogVisible) return;
      if (this.holdOrderList.length === 0) return;

      // 先清除Element UI的当前行高亮
      if (this.$refs.holdOrderTable) {
        this.$refs.holdOrderTable.setCurrentRow(null);
      }
      
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (this.selectedHoldOrderIndex > 0) {
          this.selectedHoldOrderIndex--;
        } else {
          this.selectedHoldOrderIndex = this.holdOrderList.length - 1;
        }
        // 滚动到选中的商品
        this.$nextTick(() => {
          this.scrollToSelectedHoldOrder();
          // 设置Element UI的当前行高亮
          if (this.$refs.holdOrderTable && this.selectedHoldOrderIndex >= 0) {
            const selectedRow = this.holdOrderList[this.selectedHoldOrderIndex];
            this.$refs.holdOrderTable.setCurrentRow(selectedRow);
            // 更新明细显示
            this.onHoldOrderSelectionChange(selectedRow);
          }
        });
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (this.selectedHoldOrderIndex < this.holdOrderList.length - 1) {
          this.selectedHoldOrderIndex++;
        } else {
          this.selectedHoldOrderIndex = 0;
        }
        // 滚动到选中的商品
        this.$nextTick(() => {
          this.scrollToSelectedHoldOrder();
          // 设置Element UI的当前行高亮
          if (this.$refs.holdOrderTable && this.selectedHoldOrderIndex >= 0) {
            const selectedRow = this.holdOrderList[this.selectedHoldOrderIndex];
            this.$refs.holdOrderTable.setCurrentRow(selectedRow);
            // 更新明细显示
            this.onHoldOrderSelectionChange(selectedRow);
          }
        });
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (this.selectedHoldOrderIndex >= 0 && this.selectedHoldOrderIndex < this.holdOrderList.length) {
          this.restoreHoldOrder(this.holdOrderList[this.selectedHoldOrderIndex]);
        }
      } else if (event.key === 'Escape') {
        event.preventDefault();
        this.dialogVisible = false;
      }
    },
    
    // 滚动到选中的挂单
    scrollToSelectedHoldOrder() {
      this.$nextTick(() => {
        // 查找挂单选择弹窗中的表格
        const holdOrderTable = document.querySelector('.el-dialog__wrapper:not([style*="display: none"]) .el-table');
        if (!holdOrderTable) return;

        const tableBody = holdOrderTable.querySelector('.el-table__body-wrapper');
        if (tableBody && this.selectedHoldOrderIndex >= 0) {
          const rows = tableBody.querySelectorAll('.el-table__row');
          if (rows[this.selectedHoldOrderIndex]) {
            const rowElement = rows[this.selectedHoldOrderIndex];
            const containerHeight = tableBody.clientHeight;
            const rowTop = rowElement.offsetTop;
            const rowHeight = rowElement.offsetHeight;
            const scrollTop = tableBody.scrollTop;

            // 如果行在可视区域外，则滚动到该行
            if (rowTop < scrollTop) {
              tableBody.scrollTop = rowTop;
            } else if (rowTop + rowHeight > scrollTop + containerHeight) {
              tableBody.scrollTop = rowTop + rowHeight - containerHeight;
            }
          }
        }
      });
    },
    
    // 获取挂单行样式类名
    getHoldOrderRowClassName({ rowIndex }) {
      return rowIndex === this.selectedHoldOrderIndex ? 'selected-row' : '';
    },
    
    // 挂单行点击事件
    onHoldOrderRowClick(row, column, event) {
      const index = this.holdOrderList.findIndex(item => item === row);
      if (index !== -1) {
        this.selectedHoldOrderIndex = index;
        // 设置Element UI的当前行高亮
        if (this.$refs.holdOrderTable) {
          this.$refs.holdOrderTable.setCurrentRow(row);
        }
        this.restoreHoldOrder(row);
      }
    },
    
    // 挂单行双击事件
    onHoldOrderRowTwoClick(row, column, event) {
      const index = this.holdOrderList.findIndex(item => item === row);
      if (index !== -1) {
        this.selectedHoldOrderIndex = index;
        // 设置Element UI的当前行高亮
        if (this.$refs.holdOrderTable) {
          this.$refs.holdOrderTable.setCurrentRow(row);
        }
        // 滚动到选中的商品
        this.$nextTick(() => {
          this.scrollToSelectedHoldOrder();
        });
        // 更新明细显示
        this.onHoldOrderSelectionChange(row);
      }
    },
    
    // 还原挂单
    restoreHoldOrder(order) {
      this.$emit('restore-hold-order', order);
    }
  }
};
</script>

<style scoped>
/* 选中行样式 */
::v-deep .selected-row {
  background-color: #ecf5ff !important;
}

::v-deep .selected-row:hover {
  background-color: #ecf5ff !important;
}
</style>
